import useDidUpdate from "hooks/common/useDidUpdate";
import { useState } from "react";

function usePagination(data, itemsPerPage) {
  const [currentPage, setCurrentPage] = useState(1);
  const maxPage = Math.ceil(data.length / itemsPerPage);

  function currentData() {
    const begin = (currentPage - 1) * itemsPerPage;
    const end = begin + itemsPerPage;
    return data.slice(begin, end);
  }

  function next() {
    setCurrentPage((cPage) => Math.min(cPage + 1, maxPage));
  }

  function prev() {
    setCurrentPage((cPage) => Math.max(cPage - 1, 1));
  }

  function jump(page) {
    const pageNumber = Math.max(1, page);
    setCurrentPage(() => Math.min(pageNumber, maxPage));
  }

  useDidUpdate(() => {
    setCurrentPage(1);
  }, [data, itemsPerPage]);

  return {
    next,
    prev,
    jump,
    currentData,
    currentPage,
    maxPage
  };
}

export default usePagination;
